import { reactive } from '@/core/reactive/reactive';
import { LogoutClient } from '@/core/reactive/services/sdk';
import { LoginConfig } from '@/core/config';

export const LogoutService = reactive.service(
  'logout',
  LogoutClient,
)(Service => new Service(LoginConfig.current?.api?.host ?? ''));
